import React, { useState } from "react";
import { Link } from "react-router-dom";

import Page from "pages/Page";
import { LogoutHook } from "services/Api";
import { navigate } from "utility/NavigationService";
import { useNotificationManager } from "notifications/NotificationManager";

const PageNotFound = ({ componentName = "[PageNotFound]" }) => {
    const [submitButtonText, _setSubmitButtonText] = useState("Sign in");

    const notificationManager = useNotificationManager();

    // ---=== Utilities ===--- //

    const handleSubmit = async (e) => {
        e.preventDefault();

        notificationManager.clearAllNotifications();
        void navigate("/login");
    };

    const handleSubmitButton = async (e) => {
        void handleSubmit(e);
    };

    const handleKeyPress = async (e) => {
        if (e.key === "Enter") {
            void handleSubmit(e);
        }
    };

    const logoutHook: LogoutHook = async(_componentName, _logoutReason, _onLogoutHookAccept, onLogoutHookReject) => {
        // Prevent the base Page.handleLogout() from performing a logout.
        // This allows the PageNotFound page to render its own UI without automatically
        // displaying the Login page.
        onLogoutHookReject();
    };

    // ---=== Render ===--- //

    return (
        <React.Fragment>
            <Page
                componentName={componentName}
                internal={false}
                logoutHook={logoutHook}
            >
                <div className="h-screen flex items-center justify-center pb-12 ">
                    <div className=" w-96 h-96 flex-col justify-center content-center items-center gap-8 inline-flex">
                        <div className="self-stretch h-36 flex-col justify-start items-center gap-6 flex" id="title">
                            <div className="justify-start items-start inline-flex">
                                <img className="w-12 h-12" src="/icons/icon.png" alt="Karuna Logo"/>
                            </div>
                            <div className="self-stretch h-20 flex-col justify-start items-start gap-3 flex lg:h-40">
                                <div className="self-stretch text-center text-gray-900 text-3xl font-semibold leading-9">Provider Portal</div>
                                <div className="self-stretch text-center text-gray-600 text-2xl font-normal leading-normal">
                                    Page Not Found!
                                    <br/>
                                </div>
                                <Link to={document.URL} className="self-stretch text-center text-gray-600 text-base font-normal leading-normal" style={{ textDecoration: "underline" }}>
                                    {document.URL}
                                </Link>
                            </div>
                        </div>
                        <br/>
                        <form className="w-full max-w-sm" onSubmit={handleSubmitButton} onKeyUp={(e) => handleKeyPress(e)}>
                            <div className="self-stretch h-11 flex-col justify-start items-start gap-4 flex">
                                <button type="submit" className="self-stretch px-4 py-2.5 bg-brand-600 hover:bg-brand-700 rounded-lg shadow justify-center items-center gap-1.5 inline-flex cursort-pointer">
                                    <div className="px-0.5 justify-center items-center flex">
                                        <div className="text-white text-base font-semibold leading-normal">{submitButtonText}</div>
                                    </div>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Page>
        </React.Fragment>
    );
};

export default PageNotFound;
